import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestArticles() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            深度好文
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            精选深度文章，带你了解视频文化背后的故事与趋势
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.slice(0, 6).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-accent-200 transition-all cursor-pointer"
            >
              <div className="overflow-hidden aspect-video">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  title={`${article.title} - 就要草视频`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-700 rounded">
                    {article.category === 'dianying' ? '电影' : article.category === 'dongman' ? '动漫' : article.category === 'zongyi' ? '综艺' : article.category === 'yinyue' ? '音乐' : article.category === 'youxi' ? '游戏' : article.category === 'keji' ? '科技' : '纪录片'}
                  </span>
                  <span className="text-xs text-secondary-500">{article.readTime}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-accent-600 transition-colors font-heading">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-secondary-500">
                  <span>{article.author}</span>
                  <span>{article.date}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}